import React, { useContext, useEffect } from "react";
import { StepWizardChildProps } from "react-step-wizard";
import { EntryButton } from "../components/Buttons";
import { Container } from "../components/Form";
import { HexpertContext } from "../contexts/HexPertProvider";
import { HexpertFormBlockEnum } from "../helpers/formSections";
import { IndustryListItem } from "../types/hexpertTypes";
import dataLayer from '@helpers/dataLayer';

type THexpertChooseType = {
  action?: () => void;
} & Partial<StepWizardChildProps>;

export const HexpertChooseType = ({ action, nextStep }: THexpertChooseType) => {
  const { state, dispatch } = useContext(HexpertContext);

  useEffect(() => {
    dataLayer.push('page_view', {
      page_path: window?.location?.pathname,
      page_title: 'Hexpert',
      page_category: ['hexpert'],
      page_id: window['pageId'],
    });
  }, [])
  return (
    <Container
      description={state.pageProps.IntroDescription}
      title={state.pageProps.IntroText}
      showBackButton={false}
      showNextButton={false}
    >
      {state?.pageProps?.MappedForms?.filter((el) => el.image).map((el) => (
        <EntryButton
          action={() => {
            dispatch({ type: "setCurrentForm", payload: el?.type });
            const form = state?.pageProps?.MappedForms?.find(
              (form) => form.type === el?.type
            );
            dispatch({ type: "setHexpertSteps", payload: ['hexpert', `Hexpert-${form?.title}`] })
            if (state?.currentForm?.type !== el?.type) {
              const tempDefaultAnswers = {};
              form.sections?.forEach((section) =>
                section?.questions?.forEach((question) => {
                  if (question?.ContentType === HexpertFormBlockEnum.SELECT) {
                    return;
                  }
                  if (question?.ContentType === HexpertFormBlockEnum.INDUSTRY) {
                    const defaultIndustry = question?.Options?.find(
                      (option) => option.Checked
                    );

                    if (defaultIndustry) {
                      const list = question?.List as IndustryListItem[];
                      const listInfo = list?.find(
                        (list) =>
                          list.Title?.trim() ===
                          defaultIndustry?.Caption?.trim()
                      );

                      dispatch({
                        type: "setIndustry",
                        payload: { ...listInfo, ...defaultIndustry },
                      });

                      return;
                    }
                  }
                  if (
                    question?.PredefinedValue &&
                    question?.PredefinedValue?.length > 0
                  ) {
                    tempDefaultAnswers[question?.FieldId] =
                      question?.PredefinedValue;
                  }

                  if (question?.Options?.some((option) => option?.Checked)) {
                    tempDefaultAnswers[question?.FieldId] =
                      question?.Options?.find(
                        (option) => option?.Checked
                      )?.Value;
                  }
                })
              );
              dispatch({
                type: "setDefaultAnswers",
                payload: tempDefaultAnswers,
              });
            }
            action();
            nextStep && nextStep();
          }}
          icon={el?.type}
          label={el?.title}
          fixedWidth
          key={el?.title}
        />
      ))}
    </Container>
  );
};
